import { isNil } from "ramda";
import { call, put, select } from "redux-saga/effects";

import { accountId as currentAccount, currentCourse, currentCourseId, locationSearch } from "../../selectors/selectors";
import { addPatch, createPatchBase } from "../../components/course-author/helpers/patches/creators";
import { api } from "../../dependencies";
import { AxiosInterceptedResult } from "../../api/interceptors";
import { BackgroundSettings, IFullCourse } from "../../components/course-author/types";
import { config } from "./../../config";
import { getPositionPart } from "../helpers/course";
import { IClientPatch, IPatchAddAction, IPatchPayload } from "../../components/course-author/helpers/patches";
import { IResolveResponse } from "../../api/ResolveApi/resolve-api.types";
import { patchCourseSuccess } from "./common";
import { SagaAction } from "../../sagas/types";

export function* patchCourseAndFetch(patchPayload: IPatchPayload): SagaAction {
  const accountId: string = yield select(currentAccount);
  const courseId: string = yield select(currentCourseId);
  const [patchError]: AxiosInterceptedResult<void> = yield call(
    api.courseAuthor.patchCourse,
    accountId,
    courseId,
    patchPayload
  );

  if (patchError) {
    throw new Error(patchError);
  }

  const [fetchError, response]: AxiosInterceptedResult<Array<IResolveResponse<IFullCourse>>> = yield call(
    api.resolve.courseFull.post,
    accountId,
    [courseId]
  );

  if (fetchError) {
    throw new Error(fetchError);
  }

  if (response) {
    yield put(patchCourseSuccess(response.data[0].value));
  } else {
    throw new Error("No response from fetch");
  }
}

export function* addItemToExercise<I>(item: I, exercisePosition: number, at: number): SagaAction {
  const locationQueryParams = yield select(locationSearch);
  const currentPosition: string = positionQueryParameter(locationQueryParams) || "";
  const positionPart: string = getPositionPart(currentPosition);
  const position: string = `${currentPosition}.${positionPart}.${exercisePosition}.items`;
  const accountId: string = yield select(currentAccount);
  const course: IFullCourse = yield select(currentCourse);
  const versionId = course.versionId;
  const clientPatch: IClientPatch<IPatchAddAction<I>> = {
    ...createPatchBase(accountId, versionId + 1),
    patch: addPatch<I>(item, at, position),
  };
  const patchPayload: IPatchPayload = {
    baseVersionId: versionId,
    clientPatches: [clientPatch],
  };
  return patchPayload;
}
export const positionQueryParameter = (search: string) => new URLSearchParams(search).get("position");

export const mkImageUrl = (settings?: Nullable<BackgroundSettings>) =>
  !(isNil(settings) || isNil(settings.imageId))
    ? `${config.saltcomplianceApiRoot}/images/${settings.imageId}/_download`
    : null;
